<script>
  export default {
    name: 'ListView',
    props: {
      listData: {
        type: Array,
        default () {
          return []
        }
      },
      cls: {
        type: String,
        default: ''
      }
    },
    data() {
      return {

      }
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<template>
  <!-- <transition name="slide-fade" mode="out-in"> -->
  <ul
    v-if="listData.length > 0"
    class="listview-wrap"
    :class="cls"
  >
    <slot name="preItem" />
    <slot
      v-for="(item, index) in listData"
      name="item"
      :item="item"
      :index="index"
    />
    <slot name="aftItem" />
  </ul>
  <!-- </transition> -->
</template>

<style>
  .slide-fade-enter-active {
    transition: all .3s .4s ease;
  }
  .slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active 在 <2.1.8 中 */ {
    transform: translateX(10px);
    opacity: 0;
  }
</style>